import React from "react";

/** Given the event from a PrimeReact InputText control, returns the value to be stored as a string */
export function htmlInput(event: React.FormEvent<HTMLInputElement>): string {
   return (event.target as HTMLInputElement).value;
}
export function getUrl(): string {
    return window.location.href;
}
export function getAPIUrl(): string {
    return getUrl() + 'api/';
}